import { render, staticRenderFns } from "./SwitchPopover.vue?vue&type=template&id=878dc254&scoped=true"
import script from "./SwitchPopover.vue?vue&type=script&lang=js"
export * from "./SwitchPopover.vue?vue&type=script&lang=js"
import style0 from "./SwitchPopover.vue?vue&type=style&index=0&id=878dc254&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "878dc254",
  null
  
)

export default component.exports